var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBdpBonusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.437 18L30.864 5.23c-2.591 2.618-2.665 6.822-.215 9.53l3.873 3.943-.481.486L16.862 1.833a3.044 3.044 0 00-4.339 0 3.12 3.12 0 000 4.384l13.291 13.428-.488.494-5.798-5.835.007-.008-.985-.995-.007.008L7.192 1.833a3.053 3.053 0 00-4.347 0 3.13 3.13 0 000 4.391l18.12 18.321-.482.487L5.267 9.65a3.057 3.057 0 00-4.362 0 3.134 3.134 0 000 4.406L16.122 29.43l-.474.478-6.383-6.44a3.053 3.053 0 00-4.347 0 3.13 3.13 0 000 4.39l11.863 11.985 2.043 2.095a16.966 16.966 0 0024.176 0c6.516-6.576 6.664-17.17.437-23.94",
    fill: "#0F1941"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E74536",
    cx: 35.633,
    cy: 29.027,
    rx: 4.102,
    ry: 4.145
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2175D9",
    cx: 27.421,
    cy: 20.738,
    rx: 4.102,
    ry: 4.145
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E74536",
    cx: 38.372,
    cy: 4.145,
    rx: 4.102,
    ry: 4.145
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMSkiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTQzLjQzNyAxOCAzMC44NjQgNS4yM2MtMi41OTEgMi42MTgtMi42NjUgNi44MjItLjIxNSA5LjUzbDMuODczIDMuOTQzLS40ODEuNDg2TDE2Ljg2MiAxLjgzM2EzLjA0NCAzLjA0NCAwIDAgMC00LjMzOSAwIDMuMTIgMy4xMiAwIDAgMCAwIDQuMzg0bDEzLjI5MSAxMy40MjgtLjQ4OC40OTQtNS43OTgtNS44MzUuMDA3LS4wMDgtLjk4NS0uOTk1LS4wMDcuMDA4TDcuMTkyIDEuODMzYTMuMDUzIDMuMDUzIDAgMCAwLTQuMzQ3IDAgMy4xMyAzLjEzIDAgMCAwIDAgNC4zOTFsMTguMTIgMTguMzIxLS40ODIuNDg3TDUuMjY3IDkuNjVhMy4wNTcgMy4wNTcgMCAwIDAtNC4zNjIgMCAzLjEzNCAzLjEzNCAwIDAgMCAwIDQuNDA2bDE1LjIxNyAxNS4zNzQtLjQ3NC40NzgtNi4zODMtNi40NGEzLjA1MyAzLjA1MyAwIDAgMC00LjM0NyAwIDMuMTMgMy4xMyAwIDAgMCAwIDQuMzlsMTEuODYzIDExLjk4NSAyLjA0MyAyLjA5NWExNi45NjYgMTYuOTY2IDAgMCAwIDI0LjE3NiAwYzYuNTE2LTYuNTc2IDYuNjY0LTE3LjE3LjQzNy0yMy45NCIgZmlsbD0iIzBGMTk0MSIvPgogICAgICAgIDxlbGxpcHNlIGZpbGw9IiNFNzQ1MzYiIGN4PSIzNS42MzMiIGN5PSIyOS4wMjciIHJ4PSI0LjEwMiIgcnk9IjQuMTQ1Ii8+CiAgICAgICAgPGVsbGlwc2UgZmlsbD0iIzIxNzVEOSIgY3g9IjI3LjQyMSIgY3k9IjIwLjczOCIgcng9IjQuMTAyIiByeT0iNC4xNDUiLz4KICAgICAgICA8ZWxsaXBzZSBmaWxsPSIjRTc0NTM2IiBjeD0iMzguMzcyIiBjeT0iNC4xNDUiIHJ4PSI0LjEwMiIgcnk9IjQuMTQ1Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgBdpBonusIcon as ReactComponent };